import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe, UpperCasePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgxEchartsModule } from 'ngx-echarts';
import { MaterialComponentsModule } from '../materials.module';
import {
  TranslateLoader,
  TranslateModule,
  TranslatePipe,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpClient } from '@angular/common/http';

import * as echarts from 'echarts';

import { ErrorDialogComponent } from './error-dialog/errordialog.component';
import { TotalProfitComponent } from './components/total-profit/total-profit.component';

import {
  CapitalizePipe,
  NoneScientificNotationPipe,
  TxNumberPipe,
  NumNotRoundPipe,
  StringToSplit,
  IncludesPipe
} from './pipes/common.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { RoundResultPipe } from './pipes/round-result.pipe';
import { ErrorDialogService } from './error-dialog/errordialog.service';

import {
  CopyDirective,
  CreatePermissionDirective,
  DeletePermissionDirective,
  DoubleClickDirective,
  EditPermissionDirective,
  FreezeTableDirective,
  LabelGroupDirective,
  LabelNumberDirective,
  ResizeDirective,
  DebounceClickDirective,
  NumberOnlyDirective,
  TrimValidatorDirective
} from './directives/directives';

import {
  GreaterValidator,
  LessValidator,
  MaxLengthValidator,
  MaxValidator,
  MinValidator,
} from './validators';

import { TimeStringPipe, YMDDatePipe } from './pipes/time-string.pipe';
import { TreeviewComponent } from './components/treeview/treeview.component';
import { TreeNodeService } from './components/treeview/tree-node.service';
import { Store } from './components/treeview/redux/store';
import { TabComponent } from './components/tab/tab.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { ExportButtonComponent } from './components/export-button/export-button.component';
import { LanguageSelectionComponent } from './components/language-selection/language-selection.component';
import { CoreModule } from '../core.module';
import { TimeframeComponent } from './components/timeframe/timeframe.component';
import { LightboxComponent } from './components/lightbox/lightbox.component';
import { LightboxCardComponent } from './components/lightbox-card/lightbox-card.component';
import { DialogLoadingComponent } from './components/dialog-loading/dialog-loading.component';
import { TabMenuModule } from 'primeng/tabmenu';
import { DialogComponent } from './components/dialog/dialog.component';
import { DialogPrimeComponent } from './components/dialog-prime/dialog-prime.component';

import { DialogModule } from 'primeng/dialog';
import { SaveImageComponent } from './components/save-image/save-image.component';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { PopoverComponent } from './components/popover/popover.component';
import { PopoverContentDirective } from './components/popover/popover-content.directive';
import { PopoverTriggerDirective } from './components/popover/popover-trigger.directive';

// tslint:disable-next-line:typedef
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const COMPONENTS = [
  ErrorDialogComponent,
  TotalProfitComponent,
  TreeviewComponent,
  TabComponent,
  PageHeaderComponent,
  ExportButtonComponent,
  LanguageSelectionComponent,
  TimeframeComponent,
  LightboxComponent,
  LightboxCardComponent,
  DialogComponent,
  SaveImageComponent,
  DialogPrimeComponent,
  PopoverComponent
];

const DIRECTIVES = [
  FreezeTableDirective,
  ResizeDirective,
  CreatePermissionDirective,
  EditPermissionDirective,
  DeletePermissionDirective,
  CopyDirective,
  LabelGroupDirective,
  LabelNumberDirective,
  DoubleClickDirective,
  DebounceClickDirective,
  NumberOnlyDirective,
  TrimValidatorDirective,
  PopoverContentDirective,
  PopoverTriggerDirective
];

const VALIDATORS = [
  MaxValidator,
  MinValidator,
  GreaterValidator,
  LessValidator,
  MaxLengthValidator,
];

const PIPES = [
  TxNumberPipe,
  NumNotRoundPipe,
  NoneScientificNotationPipe,
  TimeStringPipe,
  RoundResultPipe,
  CapitalizePipe,
  FilterPipe,
  StringToSplit,
  YMDDatePipe,
  IncludesPipe
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...DIRECTIVES,
    ...VALIDATORS,
    ...PIPES,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MaterialComponentsModule,
    CoreModule,
    MultiSelectModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    TabMenuModule,
    DialogModule,
    NgxImageZoomModule

  ],
  providers: [
    ErrorDialogService,
    UpperCasePipe,
    TreeNodeService,
    Store,
    TranslatePipe,
    NumNotRoundPipe,
    DecimalPipe,
  ],
  exports: [
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
    MaterialComponentsModule,
    TranslateModule,
    NgxEchartsModule,
    NgxImageZoomModule,
    YMDDatePipe
  ],
  entryComponents: [ErrorDialogComponent, DialogLoadingComponent],
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
      providers: [],
    };
  }
}
